import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationAR from "./locales/ar/text.json";
import translationDE from "./locales/de/text.json";
import translationEN from "./locales/en/text.json";
import translationES from "./locales/es/text.json";
import translationESMX from "./locales/es-MX/text.json";
import translationES419 from "./locales/es-419/text.json";
import translationFR from "./locales/fr/text.json";
import translationFRCA from "./locales/fr-CA/text.json";
import translationID from "./locales/id/text.json";
import translationIT from "./locales/it/text.json";
import translationJA from "./locales/ja/text.json";
import translationKO from "./locales/ko/text.json";
import translationPTBR from "./locales/pt-BR/text.json";
import translationZHHANS from "./locales/zh-Hans/text.json";
import translationZHHANT from "./locales/zh-Hant/text.json";

// This is a list of languages from the locales folder
export const SUPPORTED_LANGUAGES = [
  "ar",
  "de",
  "en",
  "es",
  "es-MX",
  "es-419",
  "fr",
  "fr-CA",
  "id",
  "it",
  "ja",
  "ko",
  "pt-BR",
  "zh-Hans",
  "zh-Hant",
];

export function isSupportedLanguage(lang: string) {
  return SUPPORTED_LANGUAGES.some(
    (l) => l.toLowerCase() === lang.toLowerCase()
  );
}

/** tldraw uses slightly diferent locale names than PSI, convert them */
export function toTldrawLanguage(lang: string) {
  switch (lang.toLowerCase()) {
    case "ko":
      return "ko-kr";
    case "zh-hans":
      return "zh-ch";
    case "zh-hant":
      return "zh-tw";
    default:
      return lang.toLowerCase();
  }
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    returnNull: false,
    // the translations
    resources: {
      ar: {
        translation: translationAR,
      },
      de: {
        translation: translationDE,
      },
      en: {
        translation: translationEN,
      },
      es: {
        translation: translationES,
      },
      "es-MX": {
        translation: translationESMX,
      },
      "es-419": {
        translation: translationES419,
      },
      fr: {
        translation: translationFR,
      },
      "fr-CA": {
        translation: translationFRCA,
      },
      id: {
        translation: translationID,
      },
      it: {
        translation: translationIT,
      },
      ja: {
        translation: translationJA,
      },
      ko: {
        translation: translationKO,
      },
      "pt-BR": {
        translation: translationPTBR,
      },
      "zh-Hans": {
        translation: translationZHHANS,
      },
      "zh-Hant": {
        translation: translationZHHANT,
      },
    },
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
